import React, { useEffect, useState } from 'react'
import ItemGallery from './ItemGallery'
import RenderFullImgModal from '../modal/RenderFullImgModal'
import ShowMoreButton from '../button/ShowMoreButton'
import { useParams } from 'react-router-dom'

const MasonryGallery = ({
    galleryImagesUser,
    localStorageLiked,
    addGalleryImgUser,
    itemsPicture,
    user,
    handleLoadMore,
    currentPage,
    totalPagesGallery,
    loading,
    authenticate
}) => {
    const [showModalImg, setShowModalImg] = useState(false)
    const [currentId, setCurrentId] = useState(null)
    const [currentProduct, setCurrentProduct] = useState(null)
    const [typeImgBlock, setTypeImgBock] = useState(false)

    const nameSite = useParams()

    useEffect(() => {
        if (nameSite.mainPageId && nameSite.mainPageId !== '') {
            setTypeImgBock('mainPages')
            return
        }

        setTypeImgBock('')
    }, [nameSite.mainPageId])

    const handleClick = (item) => {
        setCurrentProduct(item)
        setShowModalImg(true)
    }

    const handleShowButton = (pictureId) => {
        setCurrentId(pictureId)
    }

    const handleMouseClose = () => {
        setCurrentId(null)
    }

    return (
        <div className="masonryGallery">
            <div className="masonryGallery__grid">
                {Array.isArray(itemsPicture) && itemsPicture.map((item, index) => (
                    <ItemGallery
                        galleryImagesUser={galleryImagesUser}
                        localStorageLiked={localStorageLiked}
                        addGalleryImgUser={addGalleryImgUser}
                        key={item?._id || item?.picture?._id || index}
                        item={item}
                        handleClick={handleClick}
                        user={user}
                        handleShowButton={handleShowButton}
                        handleMouseClose={handleMouseClose}
                        currentId={currentId}
                        contentItemType={typeImgBlock}
                        authenticate={authenticate}
                    />
                ))}
            </div>

            {currentPage < totalPagesGallery ? (
                <div className="masonryGallery__showMoreBlock">
                    <ShowMoreButton
                        loading={loading}
                        currentPage={currentPage}
                        onClick={handleLoadMore}
                        whiteBackground
                        text="Показать еще"
                    />
                </div>
            ) : null}

            <RenderFullImgModal
                setCurrentIdPicture={setCurrentId}
                currentIdPicture={currentId}
                setShowModalImg={setShowModalImg}
                showModalImg={showModalImg}
                items={itemsPicture}
                typePage="galleryPage"
                product={currentProduct}
                visibleButtonsBottom={true}
            />
        </div>
    )
}

export default MasonryGallery